import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useSettings } from '@/stores/settings';
import { isPronounsField } from '@/utils/profile-fields';

import type { Account } from 'pl-api';

/** Apply display preferences without changing the account's stored profile fields. */
const useProfileFields = (account?: Pick<Account, 'fields'>) => {
  const { showPronouns } = useSettings();
  const intl = useIntl();

  return useMemo(() => {
    const fields = account?.fields ?? [];
    const label = intl.formatMessage({ id: 'account.pronouns', defaultMessage: 'pronouns' });
    return showPronouns ? fields : fields.filter(({ name }) => !isPronounsField(name, label));
  }, [account?.fields, intl, showPronouns]);
};

export { useProfileFields };
